module.exports = __webpack_public_path__ + "media/preview/workshop@4x-c7313476.png";